import { Team } from '@repo/types';
import type { TeamListProps } from './TeamList';
import { TeamCard } from '../TeamCard';

export type TeamListUIProps = Omit<TeamListProps, 'competitionId'> & {
  teams: Team[];
};

function TeamListUI({ teams, nameType, columns }: TeamListUIProps) {
  return (
    <section className="league-division-section">
      <div className="league-division-section__body">
        <ul className="league-division-section__team-list" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
          {teams.map((team) => (
            <li key={team.id} className="league-division-section__team-list-item">
              <TeamCard team={team} nameType={nameType} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TeamListUI;
